module.exports = __webpack_public_path__ + "img/expiration-extension.d56a6db0.png";